const SINGLE_PURCHASE = 'single-purchase';
const SUBSCRIPTION_PURCHASE = 'subscription-purchase';

export { SINGLE_PURCHASE, SUBSCRIPTION_PURCHASE };
//# sourceMappingURL=bloomreach.js.map
